var _circle, _path, _path2, _path3, _path4, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouldNotProcessImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 86,
    fill: "url(#paint0_linear_1730_3883)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4225 30.4959L38.2126 27.0942L29.6248 23.7707L26.1289 14L22.7206 23.526L13.5 27.0942L22.9229 30.7406L26.1289 39.7011L29.4225 30.4959Z",
    fill: "#BDC3C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.768 35C85.5378 33.6667 87.4622 33.6667 88.232 35L156.215 152.75C156.985 154.083 156.023 155.75 154.483 155.75H18.517C16.9774 155.75 16.0152 154.083 16.785 152.75L84.768 35Z",
    fill: "#8E9EAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.768 33C85.5378 31.6667 87.4622 31.6667 88.232 33L156.215 150.75C156.985 152.083 156.023 153.75 154.483 153.75H18.517C16.9774 153.75 16.0152 152.083 16.785 150.75L84.768 33Z",
    fill: "#BDC3C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.776 69.182C81.7435 68.0619 82.6375 67.1337 83.758 67.124L88.5839 67.0824C89.7044 67.0727 90.6143 67.9854 90.6011 69.1059L90.0052 119.678C89.9924 120.767 89.1112 121.645 88.0226 121.655L85.2604 121.678C84.1718 121.688 83.2756 120.825 83.244 119.737L81.776 69.182Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.7191,
    cy: 130.575,
    r: 4.45432,
    transform: "rotate(-0.49411 86.7191 130.575)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1730_3883",
    x1: 67.2184,
    y1: -292.598,
    x2: 86,
    y2: 240.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4F6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouldNotProcessImage);
export default __webpack_public_path__ + "static/media/could-not-process-image.b28acbf07f31f60688d196a09d35ed1b.svg";
export { ForwardRef as ReactComponent };